/* unplugin-vue-components disabled */import { render } from "./KilaKilaWordCloudCard.vue?vue&type=template&id=63f8c174&scoped=true"
import script from "./KilaKilaWordCloudCard.vue?vue&type=script&lang=js"
export * from "./KilaKilaWordCloudCard.vue?vue&type=script&lang=js"

import "./KilaKilaWordCloudCard.vue?vue&type=style&index=0&id=63f8c174&lang=less&scoped=true"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f8c174"]])

export default __exports__